import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { Col, Container, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import TestDetail from "./TestDetails";


import {getTestDetail} from "store/tests/actions";

class TestOverview extends Component {
  componentDidMount() {
    //params is an object with key value pairs of the url params
    const {
      match: { params }, //match : {params } so that we can access the params object containing the id passed in the url
    
      getTestDetail, //we are destructuring the props object and accessing the getServiceDetail function
    } = this.props;
    console.log(params.id);
    // if (params && params.id) {
      
    
      getTestDetail(params.id); //passing the id to the getServiceDetail action creator to get the service details
    // } 
    // else {
    //     console.log("no id")
    
    //   // remove this page from history so that the user is redirected to the home page
    //   // this.props.history.replace("/");
    // }
  }

  render() {
 const {testDetail} = this.props;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Tests" breadcrumbItem="Test Details" />
            {this.props.loading && (
              <div className="text-center " style={{
                
              }}>
                <i className="bx bx-loader bx-spin align-middle me-2" style={{fontSize:48,color:'#2A3042'}}/>
              </div>
            )}
            {!isEmpty(testDetail) && !this.props.loading && (
              <>
                
                  <Col lg="12" className="mt-0" >
                   
                    <TestDetail test={testDetail} tests={this.props.tests} />
                  </Col>

                  
             

            
              </>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

TestOverview.propTypes = {
loading: PropTypes.bool,
  match: PropTypes.object,
  testDetail: PropTypes.any,
  getTestDetail: PropTypes.func,
  tests: PropTypes.array,
};

const mapStateToProps = state => ({
  testDetail: state.TestReducer.test,
  loading: state.TestReducer.isLoading,
  tests: state.TestReducer.tests,

 
});

const mapDispatchToProps = dispatch => ({
 
 
getTestDetail: id => dispatch(getTestDetail(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TestOverview));